<template>
  <result-display
    :current-lang="$route.params.currentLang"
    :current-pattern="$route.params.currentPattern"
    :current-image-file-path="$route.params.currentImageFilePath"
    :target-url="$route.params.targetUrl">
  </result-display>
</template>

<script>
import ResultDisplay from '../components/ResultDisplay.vue'

export default {
  name: 'Result',

  components: {
    ResultDisplay,
  }
}
</script>